import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import { getActivePortalHomePath } from '@/store/identitySlice';

export function IdentityPortalRoute() {
  const isAuthenticated = useAppSelector((s) => s.identity.isAuthenticated);
  const session = useAppSelector((s) => s.identity.session);

  if (!isAuthenticated || !session) {
    return <Navigate to="/identity/login" replace />;
  }

  return <Outlet />;
}

export function IdentityPublicRoute() {
  const isAuthenticated = useAppSelector((s) => s.identity.isAuthenticated);
  const session = useAppSelector((s) => s.identity.session);

  if (isAuthenticated && session) {
    return <Navigate to={getActivePortalHomePath(session)} replace />;
  }

  return <Outlet />;
}
